import { Pipe, PipeTransform } from '@angular/core';
import { FundIdWithName } from '../../core/interfaces/fund.model';

@Pipe({
  name: 'fundIdNameFormation',
})
export class FundIdNameFormationPipe implements PipeTransform {
  transform(fundIdWIthName: FundIdWithName): string {
    return fundIdWIthName.fundPortId !== '0000' && fundIdWIthName.fundFullName !== ''
      ? `${fundIdWIthName.fundPortId} - ${fundIdWIthName.fundFullName}`
      : '';
  }
}
